import { Checkbox } from "@mui/material";
import { useLSResultsSelection } from "../../LSResultsSelectionContext";
import React from "react";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import { ResourceView } from "@tlc/ls2pac/dto/ResourceView";
import { ResourceDWR } from "@tlc/ls2pac/dto/ResourceDWR";

export const LSResultItemCheckbox = ({
  resource,
}: {
  resource: ResourceView | ResourceDWR;
}) => {
  const { translate } = useLanguage();
  const { isSelected, handleItemChange } = useLSResultsSelection();

  return (
    <Checkbox
      color="primary"
      onChange={(_, checked) => handleItemChange(resource, checked)}
      checked={isSelected(resource)}
      slotProps={{
        input: {
          "aria-label": translate("select"),
        },
      }}
    />
  );
};
